module.exports = __webpack_public_path__ + "static/media/mastervisacard.60280abe.jpeg";